// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2vy2E","bigColWidth":"Table_bigColWidth__3e9dm","biggerColWidth":"Table_biggerColWidth__1PXCH","row":"Table_row__2Bx8g","col":"Table_col__35Uq_"};